export const APP_ROLE_CODES = {
  ADMIN: 'Admin',
  USER: 'User',
};

export const APP_PERMISSIONS = {
  ACCESS_CONFIGURATION: 'accessConfiguration',
};
